// Panel package UI revision 5: compact panel and quilting checkbox rows.
(function () {
  'use strict';

  if (!document.getElementById('cd-package-list-styles')) {
    var packageStyle = document.createElement('style'); packageStyle.id = 'cd-package-list-styles';
    packageStyle.textContent = '.cd-upgrade__package-list{display:grid;gap:12px;margin:18px 0}.cd-upgrade__package-row{display:flex!important;align-items:flex-start;gap:12px;padding:14px;border:1px solid #d4d0c9;cursor:pointer}.cd-upgrade__package-row input[type=checkbox]{appearance:auto!important;-webkit-appearance:checkbox!important;position:static!important;opacity:1!important;display:block!important;width:20px!important;height:20px!important;min-width:20px;margin:3px 0 0;accent-color:#222}.cd-upgrade__package-row .cd-upgrade__row-price{margin-top:4px}.cd-upgrade__package-context{font-size:.95em;line-height:1.5;margin:8px 0 12px}.cd-upgrade__shared-option{display:block;margin-bottom:16px}.cd-upgrade__shared-option[hidden]{display:none!important}.cd-upgrade__shared-option>span{display:block;margin-bottom:8px}';
    packageStyle.textContent += '.cd-upgrade[data-package-list="true"] .cd-upgrade__package-list{gap:6px;margin:12px 0}.cd-upgrade[data-package-list="true"] .cd-upgrade__package-row{gap:9px;padding:9px 11px;min-height:44px;box-sizing:border-box;align-items:center;font-size:14px!important;line-height:1.35!important}.cd-upgrade[data-package-list="true"] .cd-upgrade__package-row>span{display:flex;flex:1;min-width:0;align-items:center;justify-content:space-between;gap:8px;flex-wrap:wrap}.cd-upgrade[data-package-list="true"] .cd-upgrade__package-row>span>span{font-size:14px!important;line-height:1.35!important;margin:0!important}.cd-upgrade[data-package-list="true"] .cd-upgrade__package-row .cd-upgrade__row-price{white-space:nowrap;margin:0!important}.cd-upgrade[data-package-list="true"] .cd-upgrade__package-row input[type="checkbox"]{width:17px!important;height:17px!important;min-width:17px;margin:0!important;flex-shrink:0}.cd-upgrade[data-package-list="true"] .cd-upgrade__shared-option{margin-bottom:10px;font-size:14px}.cd-upgrade[data-package-list="true"] .cd-upgrade__shared-option select{font-size:16px;min-height:42px;height:auto;padding:8px 32px 8px 10px}.cd-upgrade[data-package-list="true"] .cd-upgrade__package-context{font-size:13px;line-height:1.4;margin:6px 0 10px}';
    document.head.append(packageStyle);
  }


  function renderUpgradePrice(node, current, original, suffix) {
    node.replaceChildren();
    var format = function (n) { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:window.Shopify?.currency?.active || 'GBP'}).format(n / 100); };
    if (original > current) {
      var previous = document.createElement('s'); previous.className = 'cd-price-was';
      previous.textContent = format(original); node.append(previous, document.createTextNode(' '));
    }
    var now = document.createElement('span');
    now.className = original > current || current === 0 ? 'cd-price-now' : '';
    now.textContent = format(current); node.append(now);
    if (suffix) node.append(document.createTextNode(suffix));
  }
  if (!document.getElementById('cd-compare-price-styles')) {
    var style = document.createElement('style'); style.id = 'cd-compare-price-styles';
    style.textContent = '.cd-price-was{display:inline-block;position:relative;text-decoration:none;color:#777;white-space:nowrap;margin-right:6px}.cd-price-was:after{content:"";position:absolute;left:-3%;top:50%;width:106%;height:1px;background:#DB4D14;transform:rotate(-12deg)}.cd-price-now,.cd-price-saving{color:#DB4D14}.cd-upgrade-line-price{display:block;margin-top:4px}.cd-steps__chosen-total .cd-price-saving{display:block;margin-top:5px}';
    document.head.append(style);
  }


  // Dimensions are manufacturer-supplied millimetres, per selected configuration.
  function calculateDimensions(data, name, upgrades) {
    var row = data && data.configurations && data.configurations[name];
    if (!row && data && data.configurations) {
      // Match presentation differences and the confirmed website layout aliases.
      // Keep exact matches first; never guess using a partial name.
      var configurationKey = function (value) {
        var key = String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        var aliases = {
          '4seatchaisesofa': '4seaterchaisesofa',
          '5seatchaisesofa': '5seaterchaisesofa',
          '4seaterchaise': '4seaterchaisesofa',
          '5seaterchaise': '5seaterchaisesofa',
          '3seatchaisewconsolestorage': '3seatchaise',
          '3seatchaisewithconsolestorage': '3seatchaise'
        };
        return aliases[key] || key;
      };
      var targetKey = configurationKey(name);
      var matches = Object.keys(data.configurations).filter(function (key) {
        return configurationKey(key) === targetKey;
      });
      // Equivalent aliases are safe; conflicting measurements need an exact name.
      if (matches.length && matches.every(function (key) {
        return JSON.stringify(data.configurations[key]) === JSON.stringify(data.configurations[matches[0]]);
      })) row = data.configurations[matches[0]];
    }
    var positive = function (n) { return typeof n === 'number' && Number.isFinite(n) && n > 0; };
    if (!row || !positive(row.width_mm) || !positive(row.depth_mm)) return null;
    var count = 0, extraWidth = 0;
    var variants = data.console_variants || {};
    for (var item of upgrades) {
      var id = String(item.id);
      if (!Object.prototype.hasOwnProperty.call(variants, id)) continue;
      var delta = variants[id];
      if (!Number.isSafeInteger(item.quantity) || item.quantity < 1 || typeof delta !== 'number' || !Number.isFinite(delta) || delta < 0) return null;
      count += item.quantity;
      extraWidth += delta * item.quantity;
    }
    if (count && (!Number.isSafeInteger(row.max_console_replacements) || count > row.max_console_replacements)) return null;
    // Measured footprints take precedence (required for curved or non-linear layouts).
    var footprint = row.console_footprints && row.console_footprints[String(count)];
    if (footprint) {
      if (!positive(footprint.width_mm) || !positive(footprint.depth_mm)) return null;
      return { width: footprint.width_mm, depth: footprint.depth_mm, reclined: positive(footprint.reclined_depth_mm) ? footprint.reclined_depth_mm : null, count: count };
    }
    if (count && row.console_calculation !== 'linear') return null;
    return { width: row.width_mm + extraWidth, depth: row.depth_mm, reclined: positive(row.reclined_depth_mm) ? row.reclined_depth_mm : null, count: count };
  }



  function optionControl(picker, name) {
    return Array.from(picker.children).find(function (element) {
      if (!element.matches('fieldset.product-form__input, div.product-form__input')) return false;
      var label = element.querySelector('legend, .form__label');
      return label && label.textContent.trim().toLowerCase().indexOf(name) === 0;
    });
  }

  function selectedValue(control) {
    var checked = control.querySelector('input[type="radio"]:checked');
    var select = control.querySelector('select');
    return checked && checked.value || select && select.value || 'Please choose';
  }

  function makeStep(title, value) {
    var details = document.createElement('details');
    details.className = 'cd-steps__item';
    var summary = document.createElement('summary');
    var copy = document.createElement('span');
    var heading = document.createElement('strong');
    heading.className = 'cd-steps__heading';
    var stageNumber = title.match(/^\d+\./);
    if (stageNumber) {
      var number = document.createElement('span');
      number.className = 'cd-steps__number';
      number.textContent = stageNumber[0];
      heading.append(number, document.createTextNode(title.slice(stageNumber[0].length)));
    } else {
      heading.textContent = title;
    }
    var selection = document.createElement('span');
    selection.className = 'cd-steps__selection';
    selection.textContent = value;
    copy.append(heading, selection);
    summary.append(copy);
    var body = document.createElement('div');
    body.className = 'cd-steps__body';
    details.append(summary, body);
    return { details: details, body: body, selection: selection };
  }

  function upgradeStepper(input) {
    if (input.cdStepper) return input.cdStepper;
    var box = document.createElement('div'); box.className = 'cd-upgrade-stepper';
    var minus = document.createElement('button'), plus = document.createElement('button');
    minus.type = plus.type = 'button'; minus.textContent = '−'; plus.textContent = '+';
    input.before(box); box.append(minus, input, plus);
    input.style.appearance = 'textfield';
    var ceiling;
    function minimum() { return Number(input.min || 0); }
    function maximum() { var max = input.max === '' ? Infinity : Number(input.max); return ceiling === undefined ? max : Math.min(max, ceiling); }
    function refresh(limit) {
      ceiling = limit;
      var value = Number(input.value);
      minus.disabled = input.disabled || value <= minimum();
      plus.disabled = input.disabled || value >= maximum();
      minus.setAttribute('aria-label', 'Decrease ' + (input.getAttribute('aria-label') || 'quantity'));
      plus.setAttribute('aria-label', 'Increase ' + (input.getAttribute('aria-label') || 'quantity'));
    }
    function change(delta) {
      input.value = String(Math.max(minimum(), Math.min(maximum(), (Number(input.value) || minimum()) + delta)));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    minus.addEventListener('click', function () { change(-1); });
    plus.addEventListener('click', function () { change(1); });
    input.addEventListener('input', function () { refresh(ceiling); });
    input.cdStepper = { refresh: refresh }; refresh(); return input.cdStepper;
  }

  function normaliseName(value) {
    return (value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function quantityMap(card) {
    var source = card.querySelector('[data-upgrade-quantity-map]');
    var map = new Map();
    (source && source.textContent || '').split(/\r?\n/).forEach(function (line) {
      var parts = line.split(/\s*(?:=|:)\s*/);
      if (parts.length < 2 || line.includes('|')) return;
      var quantity = Number(parts.pop());
      var name = normaliseName(parts.join('='));
      if (name && Number.isSafeInteger(quantity) && quantity >= 0) map.set(name, quantity);
    });
    return map;
  }

  function controlsWarning(values, configurationName, rowQuantity) {
    var motor = values.filter(function (item) { return item.productHandle === 'triple-motor-independent-recline-upgrade'; });
    var led = values.filter(function (item) { return item.productHandle === 'led-heating-cooling-cupholder-control-with-usb-charging'; });
    if (!Number.isSafeInteger(rowQuantity) || rowQuantity < 1) return '';
    var name = normaliseName(configurationName);
    var messages = [];
    var controlItems = motor.concat(led);
    var perRow = controlItems.map(function (item) { return item.seatQuantities.get(name); }).find(function (count) { return count > 0; });
    if (motor.length && led.length && perRow) {
      var seats = perRow * rowQuantity;
      var controls = controlItems.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      if (controls > seats) messages.push('Too many controls selected. You have selected ' + controls + ' controls for ' + seats + ' seats. Reduce the combined Triple motor and LED heating/cooling quantities to ' + seats + ' or fewer.');
    }
    values.forEach(function (item) {
      var label;
      if (item.productHandle === 'triple-motor-independent-recline-upgrade') label = 'Triple motor';
      else if (item.productHandle === 'led-heating-cooling-cupholder-control-with-usb-charging') label = 'LED heating/cooling controller';
      else if (/console/i.test(item.productHandle + ' ' + item.title)) label = 'Console arm upgrade';
      if (!label) return;
      var suggested = item.seatQuantities.get(name);
      if (!suggested) return;
      var limit = suggested * rowQuantity;
      if (item.quantity > limit) messages.push(label + ': you have selected ' + item.quantity + ', which exceeds the suggested quantity of ' + limit + ' for your seating selection. Reduce the quantity to ' + limit + ' or fewer.');
    });
    return messages.join(' ');
  }

  function compactUpgrade(card, selectedUpgrades, key) {
    var content = card.querySelector('.cd-upgrade__content');
    var title = content.querySelector('h3');
    var details = content.querySelector('[data-upgrade-details]');
    var editor = document.createElement('div');
    editor.className = 'cd-upgrade__editor';
    var fields = document.createElement('div');
    fields.className = 'cd-upgrade__fields';
    var actions = document.createElement('div');
    actions.className = 'cd-upgrade__actions';
    var heading = document.createElement('div');
    heading.className = 'cd-upgrade__heading-row';
    heading.append(title);
    if (details) heading.append(details);
    var summary = document.createElement('p');
    summary.className = 'cd-upgrade__compact-summary';
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'cd-upgrade__toggle';
    Array.from(content.children).forEach(function (node) {
      if (node.matches('.cd-upgrade__option') && node.querySelector('[data-upgrade-option]')) fields.append(node);
      else if (node.matches('.cd-upgrade__option, [data-upgrade-price], [data-upgrade-add]')) actions.append(node);
      else editor.append(node);
    });
    editor.prepend(fields, actions);
    content.append(heading, summary, toggle, editor);
    card.classList.add('cd-upgrade--compact');
    function committed() {
      if (card.dataset.quantityList !== 'true') return selectedUpgrades.get(key);
      var items = Array.from(selectedUpgrades.values()).filter(function (item) { return item.upgradeKey === key; });
      if (!items.length) return null;
      var count = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      return { quantity: count, options: items.map(function (item) { return item.displayDescription || item.quantity + ' × ' + item.options.join(' / '); }), priceCents: items.reduce(function (sum, item) { return sum + item.priceCents * item.quantity; }, 0) / count, compareAtCents: items.reduce(function (sum, item) { return sum + Math.max(item.priceCents, item.compareAtCents || 0) * item.quantity; }, 0) / count };
    }
    function expanded(open) {
      editor.hidden = !open;
      var materialPreview = content.querySelector('.cd-upgrade__variant-preview');
      if (materialPreview) materialPreview.hidden = !open;
      content.classList.toggle('cd-upgrade__content--expanded', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? 'Close options' : committed() ? 'Edit selection' : 'Choose options';
      toggle.setAttribute('aria-label', toggle.textContent + ': ' + title.textContent.trim());
    }
    function refresh() {
      var choice = committed();
      var price = card.querySelector('[data-upgrade-price]');
      summary.textContent = choice
        ? (card.dataset.packageList === 'true' ? 'Selected · ' + choice.options.join(' · ') : card.dataset.panelPackage === 'true' ? 'Selected · ' + choice.options.map(function (value) { return /^(backs only|sides of arms only|fronts of arms only|tops of arms only|all panels)$/i.test(value) ? panelPackageDescription(value, choice.options[2]) : value; }).concat(choice.quantity > 1 ? [choice.quantity + ' selections'] : []).join(' · ') : '✓ Selected · ' + choice.options.concat(['Qty ' + choice.quantity]).join(' · '))
        : '';
      if (!choice) summary.replaceChildren(...Array.from(price.childNodes).map(function (node) { return node.cloneNode(true); }));
      else {
        var compactPrice = document.createElement('span'); compactPrice.className = 'cd-upgrade-line-price';
        renderUpgradePrice(compactPrice, choice.priceCents * choice.quantity, Math.max(choice.priceCents, choice.compareAtCents || 0) * choice.quantity);
        summary.append(compactPrice);
      }
      card.classList.toggle('cd-upgrade--selected', Boolean(choice));
      expanded(!editor.hidden);
    }
    toggle.addEventListener('click', function () { expanded(editor.hidden); });
    expanded(false);
    return { refresh: refresh, collapse: function () { expanded(false); toggle.focus(); } };
  }

  function variantPreview(card, selectors) {
    var material = selectors.length === 2 ? selectors[0] : selectors.find(function (select) {
      return normaliseName(select.dataset.optionName) === 'material';
    });
    if (!material) return { update: function () {} };
    var holder = document.createElement('div');
    holder.className = 'cd-upgrade__variant-preview';
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'cd-upgrade__variant-image-button';
    trigger.setAttribute('aria-haspopup', 'dialog');
    var picture = document.createElement('img');
    picture.width = 160;
    picture.height = 110;
    var caption = document.createElement('p');
    caption.setAttribute('aria-live', 'polite');
    trigger.append(picture);
    holder.append(trigger, caption);
    var content = card.querySelector('.cd-upgrade__content');
    content.classList.add('cd-upgrade__content--has-preview');
    holder.hidden = true;
    content.insertBefore(holder, content.querySelector('.cd-upgrade__editor'));
    var dialog = document.createElement('dialog');
    dialog.className = 'cd-upgrade-dialog cd-upgrade__variant-dialog';
    dialog.setAttribute('aria-label', 'Selected ' + material.dataset.optionName + ' image');
    var close = document.createElement('button');
    close.type = 'button';
    close.textContent = 'Close image';
    var large = document.createElement('img');
    dialog.append(close, large);
    card.append(dialog);
    var current;
    trigger.addEventListener('click', function () {
      if (!current || !current.image) return;
      large.src = current.imageLarge || current.image;
      large.alt = current.imageAlt || material.value;
      dialog.showModal();
      close.focus();
    });
    close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () { trigger.focus(); });
    picture.addEventListener('error', function () {
      trigger.hidden = true;
      caption.textContent = 'Material image unavailable';
    });
    return { update: function (variant) {
      // Products without individual variant artwork still have a visible preview.
      var fallback = card.querySelector('.cd-upgrade__image img');
      if (variant && !variant.image && fallback) variant = Object.assign({}, variant, { image: fallback.currentSrc || fallback.src, imageLarge: fallback.src, imageAlt: material.value });
      current = variant;
      trigger.hidden = !variant || !variant.image;
      caption.textContent = !variant ? 'Unavailable combination' : variant.image ? material.value + ' · Click to enlarge' : 'Material image unavailable';
      if (variant && variant.image) {
        picture.alt = variant.imageAlt || material.value;
        trigger.setAttribute('aria-label', 'Enlarge ' + material.value + ' image');
        if (picture.getAttribute('src') !== variant.image) picture.src = variant.image;
      } else {
        picture.removeAttribute('src');
      }
    } };
  }

  // Match whole words, allowing names such as "Dakota leather" and grouped models.
  function matchWords(value) {
    return normaliseName(value).replace(/inslington/g, 'islington').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  // Package counts use the agreed standard layouts; bespoke layouts need their own entry.
  function panelPackageCounts(configuration) {
    var layouts = {
      'single seat': [1, 2, 2], 'loveseat': [2, 2, 2], 'daybed': [1, 2, 2],
      'chaise': [1, 1, 1], '3 seat sofa': [3, 2, 2], '4 seat sofa': [4, 2, 2], '5 seat sofa': [5, 2, 2],
      '3 seat sofa twin chaise': [3, 2, 4], '4 seat sofa twin chaise': [4, 2, 2],
      '5 seat sofa twin chaise': [5, 2, 2]
    };
    var key = matchWords(configuration).replace(/\bwith\b/g, '').replace(/\s+/g, ' ').trim();
    var row = key.match(/^row of ([2-5])$/);
    var counts = row ? [Number(row[1]), 2, Number(row[1]) + 1] : layouts[key];
    return counts ? {backs: counts[0], sides: counts[1], fronts: counts[2], tops: counts[2]} : null;
  }

  function panelPackageDescription(packageName, configuration, limits) {
    var counts = panelPackageCounts(configuration), name = matchWords(packageName);
    // The editor can override displayed panel counts without multiplying package prices.
    var aliases = {
      backs: ['backs', 'backs only', 'headrest'],
      sides: ['exposed arm sides only', 'sides of arms', 'sides of arms only', 'arm sides'],
      fronts: ['fronts of arms', 'fronts of arms only', 'arm fronts'],
      tops: ['tops of arms', 'tops of arms only', 'arm tops']
    };
    counts = Object.assign({}, counts || {});
    if (limits) Object.keys(aliases).forEach(function (area) {
      for (var alias of aliases[area]) {
        var explicit = limits.get(normaliseName(configuration) + '|' + normaliseName(alias));
        if (explicit !== undefined) { counts[area] = explicit; break; }
      }
    });
    var labels = {'backs only': ['Backs', 'backs'], 'exposed arm sides only': ['Exposed arm sides', 'sides'], 'sides of arms only': ['Sides of arms', 'sides'],
      'fronts of arms only': ['Fronts of arms', 'fronts'], 'tops of arms only': ['Tops of arms', 'tops']};
    if (name === 'all panels') return 'All panels — complete selection' + (['backs', 'sides', 'fronts', 'tops'].every(function (area) { return Number.isSafeInteger(counts[area]); }) ? ' (' + (counts.backs + counts.sides + counts.fronts + counts.tops) + ' panels)' : '');
    var entry = labels[name];
    return entry && Number.isSafeInteger(counts[entry[1]]) ? entry[0] + ' — all ' + counts[entry[1]] + ' panel' + (counts[entry[1]] === 1 ? '' : 's') : packageName;
  }

  function configurationValue(values, context) {
    function key(value) { return matchWords(value).replace(/\bwith\b/g, '').replace(/\s+/g, ' ').trim(); }
    var matches = values.filter(function (value) { return key(value) === key(context); });
    return matches.length === 1 ? matches[0] : null;
  }

  function automaticValue(values, context, covering) {
    var text = ' ' + matchWords(context) + ' ';
    var matches = values.filter(function (value) {
      var words = matchWords(value);
      if (!words) return false;
      if (covering) {
        var families = ['velvet', 'dakota', 'nappa'];
        var family = families.find(function (name) { return text.includes(' ' + name + ' '); });
        return words === matchWords(context) || Boolean(family && (' ' + words + ' ').includes(' ' + family + ' '));
      }
      return value.split(/\s*(?:\/|,|&|\band\b)\s*/i).some(function (part) {
        var model = matchWords(part);
        return model && text.includes(' ' + model + ' ');
      });
    });
    return matches.length === 1 ? matches[0] : null;
  }

  function listContext(card, variants, selectors, coveringControl) {
    var context = card.dataset.seatProductTitle + ' ' + card.dataset.seatProductHandle;
    var covering = coveringControl ? selectedValue(coveringControl) : '';
    var automatic = [], choices = {}, missing = false;
    selectors.forEach(function (select, index) {
      var name = matchWords(select.dataset.optionName);
      var model = ['seat type', 'sofa model', 'seat model', 'model'].includes(name);
      var matchCovering = ['seat covering', 'covering', 'covering material', 'upholstery'].includes(name) || (name === 'material' && /console/i.test(card.dataset.upgradeProductHandle + ' ' + card.querySelector('h3').textContent));
      if (!model && !matchCovering) return;
      automatic.push(index);
      var values = Array.from(new Set(variants.map(function (variant) { return variant.options[index]; })));
      var choice = automaticValue(values, model ? context : covering, matchCovering);
      // A single fixed value needs no ambiguous model/covering inference.
      if (!choice && values.length === 1) choice = values[0];
      if (!choice) missing = true;
      choices[index] = choice;
    });
    return { automatic: automatic, missing: missing, variants: missing ? [] : variants.filter(function (variant) { return automatic.every(function (index) { return variant.options[index] === choices[index]; }); }) };
  }

  function quantityLimits(card) {
    var rules = new Map();
    // Accept row rules in the established quantity field as well as the new limits field.
    // Dedicated limits take precedence when both fields define the same row.
    var sources = ['[data-upgrade-quantity-map]', '[data-upgrade-row-limits]'];
    sources.forEach(function (selector) {
      var source = card.querySelector(selector);
      (source && source.textContent || '').split(/\r?\n/).forEach(function (line) {
      var match = line.match(/^\s*(.*?)\s*\|\s*(.*?)\s*=\s*(\d+)\s*$/);
      if (!match) return;
      var number = Number(match[3]);
      if (Number.isSafeInteger(number)) rules.set(normaliseName(match[1]) + '|' + normaliseName(match[2]), number);
    });
    });
    return rules;
  }

  function bootQuantityList(card, selections, drafts, configurationName, refreshSelection, variants, selectors, coveringControl) {
    var key = card.dataset.upgradeKey;
    var limits = quantityLimits(card);
    function maximum(location) {
      var value = limits.get(normaliseName(configurationName) + '|' + normaliseName(location));
      return value === undefined ? undefined : value * (Number(card.dataset.seatOrderQuantity) || 1);
    }
    card.dataset.quantityList = 'true';
    var compact = compactUpgrade(card, selections, key);
    var preview = variantPreview(card, selectors);
    var editor = card.querySelector('.cd-upgrade__editor');
    var actions = card.querySelector('.cd-upgrade__actions');
    card.querySelector('.cd-upgrade__fields').hidden = true;
    card.querySelector('[data-upgrade-quantity]').closest('.cd-upgrade__option').hidden = true;
    var price = card.querySelector('[data-upgrade-price]'); price.hidden = true;
    var add = card.querySelector('[data-upgrade-add]'), remove = card.querySelector('[data-upgrade-remove]');
    var status = card.querySelector('[data-upgrade-status]'), note = card.querySelector('[data-upgrade-quantity-note]');
    var quantities = quantityMap(card), suggested = quantities.get(normaliseName(configurationName));
    var explanation = (card.querySelector('[data-upgrade-quantity-explanation]')?.textContent || '').trim();
    note.hidden = !suggested;
    note.textContent = suggested ? 'Suggested total: ' + suggested + (explanation ? ' — ' + explanation : '') : '';
    editor.append(note);
    var list = document.createElement('div'); list.className = 'cd-upgrade__quantity-list'; actions.before(list);
    var summary = document.createElement('div'); summary.className = 'cd-upgrade__list-summary'; summary.setAttribute('aria-live', 'polite'); actions.prepend(summary);
    var sharedField = document.createElement('label'); sharedField.className = 'cd-upgrade__shared-option';
    var sharedLabel = document.createElement('span'); var shared = document.createElement('select');
    sharedField.append(sharedLabel, shared); list.before(sharedField); sharedField.hidden = true;
    shared.addEventListener('change', update);
    var rows = [], currentVariants = [], primaryIndex = -1, secondaryIndex = -1, signature;
    var unit = /panel/i.test(card.querySelector('h3').textContent) ? 'panel' : 'item';
    function committedRows() { return Array.from(selections.values()).filter(function (item) { return item.upgradeKey === key; }); }
    function variantFor(row) { return currentVariants.find(function (variant) { return (primaryIndex < 0 || variant.options[primaryIndex] === row.location) && (secondaryIndex < 0 || variant.options[secondaryIndex] === shared.value); }); }
    function update() {
      var count = 0, total = 0, original = 0, invalid = !rows.length, previewVariant = null;
      var state = { rows: {}, preview: '', shared: shared.value };
      rows.forEach(function (row) {
        var variant = variantFor(row), qty = Number(row.count.value);
        var valid = row.count.value !== '' && Number.isSafeInteger(qty) && qty >= 0;
        var limit = maximum(row.location);
        var excess = limit !== undefined && valid && qty > limit;
        if (limit === undefined) row.count.removeAttribute('max'); else row.count.max = String(limit);
        row.label.textContent = row.location + (limit !== undefined ? ' (max ' + limit + ')' : '');
        row.count.setAttribute('aria-label', row.label.textContent + ' quantity');
        row.limit.hidden = !excess;
        row.limit.textContent = excess ? 'Maximum: ' + limit + '. Reduce this quantity to continue.' : '';
        row.limit.classList.toggle('cd-upgrade__limit--exceeded', excess);
        row.count.setAttribute('aria-invalid', String(!valid || excess));
        if (excess) invalid = true;
        if (!valid || (qty > 0 && (!variant || !variant.available))) invalid = true;
        if (variant) renderUpgradePrice(row.price, variant.priceCents, variant.compareAtCents, ' each'); else row.price.textContent = 'Unavailable';
        if (valid && qty > 0 && variant) { count += qty; total += qty * variant.priceCents; original += qty * Math.max(variant.priceCents, variant.compareAtCents || 0); }
        state.rows[row.location] = { material: shared.value, quantity: row.count.value };
        if (row.radio.checked) {
          state.preview = row.location;
          previewVariant = variant;
          selectors.forEach(function (select, index) { if (variant) select.value = variant.options[index]; });
          preview.update(variant);
        }
      });
      var hasRowLimits = rows.some(function (row) { return maximum(row.location) !== undefined; });
      var totalBase = quantities.get(normaliseName(configurationName));
      var totalLimit = totalBase === undefined ? undefined : totalBase * (Number(card.dataset.seatOrderQuantity) || 1);
      rows.forEach(function (row) {
        var remaining = !hasRowLimits && totalLimit !== undefined ? Math.max(0, totalLimit - count + Number(row.count.value || 0)) : undefined;
        row.count.cdStepper.refresh(remaining);
      });
      var totalExcess = !hasRowLimits && totalLimit !== undefined && count > totalLimit;
      if (totalExcess) invalid = true;
      note.hidden = hasRowLimits || totalLimit === undefined;
      note.textContent = totalLimit === undefined ? '' : 'Maximum total: ' + totalLimit + (totalExcess ? ' — reduce the quantities to continue.' : (explanation ? ' — ' + explanation : ''));
      drafts.set(key, state);
      summary.replaceChildren();
      var title = document.createElement('strong'); title.textContent = count + ' ' + unit + (count === 1 ? '' : 's') + ' · '; summary.append(title);
      var cost = document.createElement('span'); renderUpgradePrice(cost, total, original); summary.append(cost);
      rows.forEach(function (row) { if (Number(row.count.value) > 0) { var detail = document.createElement('div'); detail.textContent = row.count.value + ' × ' + row.location + (secondaryIndex >= 0 ? ' — ' + shared.value : ''); summary.append(detail); } });
      var selected = committedRows(); add.disabled = invalid || (!count && !selected.length);
      add.textContent = selected.length ? 'Update selection' : 'Add to selection'; remove.hidden = !selected.length;
      if (count) renderUpgradePrice(price, total, original); else price.textContent = rows.length ? 'Choose quantities' : 'Unavailable for this seating selection';
      if (!previewVariant) preview.update(null);
      var offer = card.querySelector('[data-upgrade-free-offer]');
      if (offer) offer.hidden = !previewVariant || !previewVariant.available || previewVariant.priceCents !== 0 || !(previewVariant.compareAtCents > previewVariant.priceCents);
      compact.refresh();
    }
    function rebuild() {
      var filtered = listContext(card, variants, selectors, coveringControl);
      var nextSignature = JSON.stringify(filtered.variants.map(function (variant) { return variant.id; }));
      if (nextSignature === signature) return;
      signature = nextSignature; currentVariants = filtered.variants;
      // Hide fixed and automatically matched options. Remaining options define rows and (if needed) the second selector.
      var manual = selectors.map(function (_, index) { return index; }).filter(function (index) { return !filtered.automatic.includes(index); });
      var preferred = Number(card.dataset.sharedOption || 1) - 1;
      secondaryIndex = manual.length > 1 ? (manual.includes(preferred) ? preferred : manual[0]) : -1;
      primaryIndex = manual.length > 1 ? manual.find(function (index) { return index !== secondaryIndex; }) : manual.length ? manual[0] : -1;
      var saved = drafts.get(key); rows = []; list.replaceChildren();
      shared.replaceChildren(); sharedField.hidden = secondaryIndex < 0;
      if (secondaryIndex >= 0) {
        sharedLabel.textContent = selectors[secondaryIndex].dataset.optionName;
        shared.setAttribute('aria-label', sharedLabel.textContent);
        Array.from(new Set(currentVariants.map(function (variant) { return variant.options[secondaryIndex]; }))).forEach(function (value) {
          var option = document.createElement('option'); option.value = value; option.textContent = value;
          option.disabled = !currentVariants.some(function (variant) { return variant.options[secondaryIndex] === value && variant.available; });
          if (option.disabled) option.textContent += ' — sold out'; shared.append(option);
        });
        var desired = saved && saved.shared || committedRows()[0]?.options[secondaryIndex];
        var available = Array.from(shared.options).find(function (option) { return !option.disabled; });
        if (desired && Array.from(shared.options).some(function (option) { return option.value === desired; })) shared.value = desired;
        else if (available) shared.value = available.value;
      }
      var locations = primaryIndex >= 0 ? Array.from(new Set(currentVariants.map(function (variant) { return variant.options[primaryIndex]; }))) : currentVariants.length ? [card.querySelector('h3').textContent.trim()] : [];
      locations.forEach(function (location) {
        var row = document.createElement('div'); row.className = 'cd-upgrade__quantity-row cd-upgrade__quantity-row--single';
        var radio = document.createElement('input'); radio.type = 'radio'; radio.name = 'cd-preview-' + key + '-' + card.closest('[data-cinema-deco-steps]')?.id; radio.setAttribute('aria-label', 'Preview ' + location); radio.checked = saved && saved.preview === location;
        var label = document.createElement('span'); label.textContent = location;
        var material = document.createElement('select'); material.hidden = true;
        var count = document.createElement('input'); count.type = 'number'; count.min = '0'; count.step = '1'; count.value = '0'; count.inputMode = 'numeric'; count.setAttribute('aria-label', location + ' quantity');
        var restored = saved && saved.rows && saved.rows[location];
        var committed = committedRows().find(function (item) { return item.location === location; });
        if (restored) count.value = restored.quantity;
        else if (committed) count.value = committed.quantity;
        var rowPrice = document.createElement('span'); rowPrice.className = 'cd-upgrade__row-price'; var limitNote = document.createElement('span'); limitNote.className = 'cd-upgrade__row-limit'; limitNote.id = 'cd-limit-' + key + '-' + rows.length; count.setAttribute('aria-describedby', limitNote.id); row.append(radio, label, material, count, rowPrice); list.append(row, limitNote); upgradeStepper(count);
        rows.push({location:location,label:label,radio:radio,material:material,count:count,price:rowPrice,limit:limitNote}); radio.addEventListener('change',update);material.addEventListener('change',update);count.addEventListener('input',update);
      });
      if (!rows.some(function (row) { return row.radio.checked; }) && rows.length) rows[0].radio.checked = true;
      if (!rows.length) { var warning = document.createElement('p'); warning.textContent = 'This upgrade has no matching option for your seating configuration, sofa and covering.'; list.append(warning); }
      // Keep committed rows tied to the current sofa/covering; remove incompatible choices explicitly.
      var changed = false;
      selections.forEach(function (item, id) { if (item.upgradeKey !== key) return; var row = rows.find(function (row) { return row.location === item.location; }); var variant = row && currentVariants.find(function (variant) { return (primaryIndex < 0 || variant.options[primaryIndex] === row.location) && (secondaryIndex < 0 || variant.options[secondaryIndex] === item.options[secondaryIndex]); }); if (!variant || !variant.available) { selections.delete(id); changed = true; } else if (item.id !== variant.id) { Object.assign(item,{id:variant.id, options:variant.options,priceCents:variant.priceCents,compareAtCents:variant.compareAtCents,depositPlanIds:variant.depositPlanIds}); changed = true; } });
      if (changed) status.textContent = 'Upgrade selection updated to match your seating configuration, sofa and covering.';
      update(); if (changed) refreshSelection();
    }
    add.addEventListener('click', function () {
      update(); if (add.disabled) return;
      var pending = rows.filter(function (row) { return Number(row.count.value) > 0; }).map(function (row) { var variant = variantFor(row); return {upgradeKey:key,productHandle:card.dataset.upgradeProductHandle,seatQuantities:quantities,id:variant.id,quantity:Number(row.count.value),title:card.querySelector('h3').textContent.trim(),options:variant.options.filter(function (value) { return value !== 'Default Title'; }),depositPlanIds:variant.depositPlanIds,compareAtCents:variant.compareAtCents,priceCents:variant.priceCents,location:row.location}; });
      selections.forEach(function(item,id){if(item.upgradeKey===key)selections.delete(id);});pending.forEach(function(item){selections.set(key+'::'+item.location,item);});status.textContent=pending.length?'Selected. These upgrades will be added with your seat.':'Upgrades removed from your selection.';update();refreshSelection();compact.collapse();
    });
    remove.addEventListener('click',function(){selections.forEach(function(item,id){if(item.upgradeKey===key)selections.delete(id);});rows.forEach(function(row){row.count.value='0';});status.textContent='Upgrades removed from your selection.';update();refreshSelection();compact.collapse();});
    card.refreshQuantityLimits = update;
    card.committedQuantityLimitError = function () {
      var invalid = committedRows().find(function (item) { var limit = maximum(item.location); return limit !== undefined && item.quantity > limit; });
      var base = quantities.get(normaliseName(configurationName));
      var totalLimit = base === undefined ? undefined : base * (Number(card.dataset.seatOrderQuantity) || 1);
      if (!rows.some(function (row) { return maximum(row.location) !== undefined; }) && totalLimit !== undefined && committedRows().reduce(function (sum, item) { return sum + item.quantity; }, 0) > totalLimit) return card.querySelector('h3').textContent.trim() + ' exceeds the maximum total of ' + totalLimit + '. Edit the upgrade selection before adding your seat.';
      return invalid ? card.querySelector('h3').textContent.trim() + ': ' + invalid.location + ' exceeds the maximum of ' + maximum(invalid.location) + '. Edit the upgrade selection before adding your seat.' : '';
    };
    card.syncSeatOptions = function (name) {
      if (name) configurationName = name;
      suggested = quantities.get(normaliseName(configurationName));
      note.textContent = suggested ? 'Suggested total: ' + suggested + (explanation ? ' — ' + explanation : '') : '';
      rebuild(); update();
    };
    rebuild();
  }

  function bindUpgradeDetails(detailsButton, detailsDialog) {
    if (detailsButton && detailsDialog) {
      var gallery = detailsDialog.querySelector('[data-upgrade-gallery]');
      if (gallery) {
        var galleryImage = gallery.querySelector('[data-upgrade-gallery-image]');
        var galleryItems = Array.from(gallery.querySelectorAll('[data-upgrade-gallery-item]'));
        var previousImage = detailsDialog.querySelector('[data-upgrade-gallery-previous]');
        var nextImage = detailsDialog.querySelector('[data-upgrade-gallery-next]');
        var galleryIndex = Math.max(0, galleryItems.findIndex(function (item) {
          return item.dataset.current === 'true';
        }));
        function showGalleryImage(index) {
          if (!galleryItems.length || !galleryImage) return;
          galleryIndex = (index + galleryItems.length) % galleryItems.length;
          var item = galleryItems[galleryIndex];
          galleryImage.src = item.dataset.imageUrl;
          galleryImage.alt = item.dataset.imageAlt || '';
        }
        if (previousImage) previousImage.addEventListener('click', function () { showGalleryImage(galleryIndex - 1); });
        if (nextImage) nextImage.addEventListener('click', function () { showGalleryImage(galleryIndex + 1); });
        if (galleryItems.length < 2) {
          if (previousImage) previousImage.hidden = true;
          if (nextImage) nextImage.hidden = true;
        }
        if (galleryItems.length) showGalleryImage(galleryIndex);
        detailsDialog.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') showGalleryImage(galleryIndex - 1);
          if (event.key === 'ArrowRight') showGalleryImage(galleryIndex + 1);
        });
      }
      detailsButton.addEventListener('click', function () {
        if (typeof detailsDialog.showModal === 'function') detailsDialog.showModal();
        else detailsDialog.setAttribute('open', '');
      });
      detailsDialog.querySelectorAll('[data-upgrade-dialog-close]').forEach(function (close) {
        close.addEventListener('click', function () { detailsDialog.close(); });
      });
      detailsDialog.addEventListener('click', function (event) {
        if (event.target === detailsDialog) detailsDialog.close();
      });
    }
  }

  function packageListContext(card, variants, selectors, coveringControl, configuration) {
    var context = listContext(card, variants, selectors, coveringControl);
    selectors.forEach(function (select, index) {
      if (!['configuration', 'seating configuration', 'seat configuration'].includes(matchWords(select.dataset.optionName))) return;
      context.automatic.push(index);
      var choice = configurationValue(Array.from(new Set(variants.map(function (variant) { return variant.options[index]; }))), configuration);
      if (!choice) context.missing = true;
      context.variants = choice ? context.variants.filter(function (variant) { return variant.options[index] === choice; }) : [];
    });
    return context;
  }

  function packageAreaCount(location, configuration, limits) {
    var explicit = limits.get(normaliseName(configuration) + '|' + normaliseName(location));
    if (explicit !== undefined) return explicit;
    var counts = panelPackageCounts(configuration), name = matchWords(location);
    if (!counts) return null;
    if (/front/.test(name)) return counts.fronts;
    if (/top/.test(name)) return counts.tops;
    if (/side/.test(name)) return counts.sides;
    if (/headrest|footrest|back/.test(name)) return counts.backs;
    return null;
  }

  function isCompletePackage(value) {
    return /^(all panels|all areas|complete upholstery|all upholstery)$/.test(matchWords(value));
  }

  function setPackageChecks(rows, changed) {
    if (changed && isCompletePackage(changed.location) && changed.check.checked) {
      rows.forEach(function (row) { if (row !== changed) row.check.checked = false; });
    }
    var complete = rows.some(function (row) { return isCompletePackage(row.location) && row.check.checked; });
    rows.forEach(function (row) {
      if (complete && !isCompletePackage(row.location)) row.check.checked = false;
      row.blockedByComplete = complete && !isCompletePackage(row.location);
    });
  }

  function bootPackageList(card, selections, drafts, configuration, refreshSelection, variants, selectors, coveringControl, panels) {
    var key = card.dataset.upgradeKey;
    card.dataset.quantityList = 'true';
    card.dataset.packageList = 'true';
    // Panel variants are whole packages. Existing quilting variants are priced per area.
    var packaged = panels || selectors.some(function (select) { return ['configuration', 'seating configuration', 'seat configuration'].includes(matchWords(select.dataset.optionName)); });
    var limits = quantityLimits(card), quantities = quantityMap(card);
    var compact = compactUpgrade(card, selections, key), preview = variantPreview(card, selectors);
    var editor = card.querySelector('.cd-upgrade__editor'), actions = card.querySelector('.cd-upgrade__actions');
    card.querySelector('.cd-upgrade__fields').style.setProperty('display', 'none', 'important');
    card.querySelector('[data-upgrade-quantity]').closest('.cd-upgrade__option').style.setProperty('display', 'none', 'important');
    var price = card.querySelector('[data-upgrade-price]'); price.hidden = true;
    card.querySelector('[data-upgrade-quantity-note]').hidden = true;
    var add = card.querySelector('[data-upgrade-add]'), remove = card.querySelector('[data-upgrade-remove]'), status = card.querySelector('[data-upgrade-status]');
    var reminder = document.createElement('p'); reminder.className = 'cd-upgrade__package-context';
    card.querySelector('.cd-upgrade__heading-row').after(reminder);
    var sharedField = document.createElement('label'); sharedField.className = 'cd-upgrade__shared-option';
    var sharedLabel = document.createElement('span'), shared = document.createElement('select');
    sharedField.append(sharedLabel, shared); actions.before(sharedField);
    var list = document.createElement('div'); list.className = 'cd-upgrade__package-list'; actions.before(list);
    var summary = document.createElement('p'); summary.className = 'cd-upgrade__list-summary'; summary.setAttribute('aria-live', 'polite'); actions.prepend(summary);
    var rows = [], current = [], primary = -1, secondary = -1, signature, previewLocation;
    function committed() { return Array.from(selections.values()).filter(function (item) { return item.upgradeKey === key; }); }
    function seatQuantity() { var value = Number(card.dataset.seatOrderQuantity || 1); return Number.isSafeInteger(value) && value > 0 ? value : 0; }
    function variantFor(location, material) { return current.find(function (variant) { return (primary < 0 || variant.options[primary] === location) && (secondary < 0 || variant.options[secondary] === material); }); }
    function areaCount(location) { return panels ? 1 : packageAreaCount(location, configuration, limits); }
    function labelFor(location) {
      if (panels) return panelPackageDescription(location, configuration, limits);
      var count = packageAreaCount(location, configuration, limits);
      return isCompletePackage(location) ? 'All upholstery — complete selection' : location + (count === null ? '' : ' — all ' + count + ' area' + (count === 1 ? '' : 's'));
    }
    function cartQuantity(location) { var count = packaged ? 1 : areaCount(location); return count === null ? 0 : count * seatQuantity(); }
    function updateCommitted() {
      var changed = false;
      committed().forEach(function (item) {
        var variant = variantFor(item.location, secondary < 0 ? '' : item.options[secondary]);
        var count = cartQuantity(item.location), areas = areaCount(item.location);
        if (!variant || !variant.available || count < 1 || areas === null || areas === 0) {
          selections.delete(key + '::' + item.location); changed = true; return;
        }
        if (item.id !== variant.id || item.quantity !== count) changed = true;
        Object.assign(item, {id:variant.id, options:variant.options, quantity:count, priceCents:variant.priceCents, compareAtCents:variant.compareAtCents, depositPlanIds:variant.depositPlanIds,
          displayDescription: configuration + ' · ' + labelFor(item.location) + (secondary < 0 ? '' : ' · ' + item.options[secondary]) + (seatQuantity() > 1 ? ' · ' + seatQuantity() + ' selections' : '')});
      });
      return changed;
    }
    function update() {
      setPackageChecks(rows);
      var total = 0, original = 0, selectedCount = 0, invalid = !rows.length || !seatQuantity();
      var state = {shared:shared.value, rows:{}, preview:previewLocation};
      rows.forEach(function (row) {
        var variant = variantFor(row.location, shared.value), quantity = cartQuantity(row.location), areas = areaCount(row.location);
        var unavailable = !variant || !variant.available || areas === null || areas === 0 || quantity < 1;
        row.check.disabled = row.blockedByComplete || unavailable;
        row.node.style.opacity = row.blockedByComplete ? '0.45' : '1';
        row.label.textContent = labelFor(row.location);
        if (unavailable) row.price.textContent = areas === null ? 'Quantity not configured' : !variant ? 'Unavailable' : !variant.available ? 'Sold out' : 'Not applicable';
        else renderUpgradePrice(row.price, variant.priceCents * quantity, Math.max(variant.priceCents, variant.compareAtCents || 0) * quantity, ' total');
        if (row.check.checked) {
          if (unavailable) invalid = true;
          else { selectedCount++; total += variant.priceCents * quantity; original += Math.max(variant.priceCents, variant.compareAtCents || 0) * quantity; }
        }
        state.rows[row.location] = {checked:row.check.checked};
      });
      drafts.set(key, state);
      var previewRow = rows.find(function (row) { return row.location === previewLocation; }) || rows.find(function (row) { return row.check.checked; }) || rows[0];
      var previewVariant = previewRow && variantFor(previewRow.location, shared.value);
      if (previewVariant) selectors.forEach(function (select, index) { select.value = previewVariant.options[index]; });
      preview.update(previewVariant || null);
      var offer = card.querySelector('[data-upgrade-free-offer]');
      if (offer) offer.hidden = !previewVariant || !previewVariant.available || previewVariant.priceCents !== 0 || !(previewVariant.compareAtCents > 0);
      summary.replaceChildren();
      summary.append(document.createTextNode(selectedCount + ' package' + (selectedCount === 1 ? '' : 's') + ' · '));
      renderUpgradePrice(price, total, original, ' total for your ' + configuration + (seatQuantity() > 1 ? ' × ' + seatQuantity() : ''));
      var amount = document.createElement('span'); renderUpgradePrice(amount, total, original); summary.append(amount);
      add.disabled = invalid || (!selectedCount && !committed().length);
      add.textContent = committed().length ? 'Update upgrade selection' : 'Add upgrades to selection';
      remove.hidden = !committed().length;
      var text = 'For your ' + configuration + (seatQuantity() > 1 ? ' × ' + seatQuantity() : '') + ' — choose the areas to upgrade across the whole selection.';
      if (reminder.textContent !== text) reminder.textContent = text;
      compact.refresh();
    }
    function rebuild() {
      var context = packageListContext(card, variants, selectors, coveringControl, configuration);
      var next = configuration + '|' + JSON.stringify(context.variants.map(function (variant) { return variant.id; }));
      if (next === signature) return;
      signature = next; current = context.variants;
      var manual = selectors.map(function (_, index) { return index; }).filter(function (index) { return !context.automatic.includes(index); });
      secondary = manual.find(function (index) { return /^(material|quilting pattern|quilt pattern|pattern)$/.test(matchWords(selectors[index].dataset.optionName)); });
      if (secondary === undefined) secondary = manual.length > 1 ? manual[0] : -1;
      primary = manual.find(function (index) { return index !== secondary; });
      if (primary === undefined) primary = -1;
      // More than two manual options cannot be inferred safely.
      if (manual.length > 2) current = [];
      var saved = drafts.get(key); shared.replaceChildren(); sharedField.hidden = secondary < 0;
      if (secondary >= 0) {
        sharedLabel.textContent = selectors[secondary].dataset.optionName;
        Array.from(new Set(current.map(function (variant) { return variant.options[secondary]; }))).forEach(function (value) {
          var option = document.createElement('option'); option.value = value; option.textContent = value;
          option.disabled = !current.some(function (variant) { return variant.options[secondary] === value && variant.available; }); shared.append(option);
        });
        var desired = saved && saved.shared || committed()[0]?.options[secondary];
        var available = Array.from(shared.options).find(function (option) { return !option.disabled; });
        if (desired && Array.from(shared.options).some(function (option) { return option.value === desired && !option.disabled; })) shared.value = desired;
        else if (available) shared.value = available.value;
      }
      list.replaceChildren(); rows = [];
      var locations = primary < 0 ? (current.length ? [card.querySelector('h3').textContent.trim()] : []) : Array.from(new Set(current.map(function (variant) { return variant.options[primary]; })));
      locations.forEach(function (location) {
        var node = document.createElement('label'); node.className = 'cd-upgrade__package-row';
        var check = document.createElement('input'); check.type = 'checkbox';
        var copy = document.createElement('span'), label = document.createElement('span'), rowPrice = document.createElement('span');
        rowPrice.className = 'cd-upgrade__row-price'; label.style.display = 'block'; rowPrice.style.display = 'block'; copy.append(label, rowPrice); node.append(check, copy); list.append(node);
        var restored = saved && saved.rows && saved.rows[location];
        check.checked = restored ? Boolean(restored.checked) : committed().some(function (item) { return item.location === location; });
        var row = {location:location, check:check, label:label, price:rowPrice, node:node}; rows.push(row);
        check.addEventListener('change', function () { previewLocation = location; setPackageChecks(rows, row); update(); });
      });
      if (!rows.length) { var warning = document.createElement('p'); warning.textContent = 'No matching upgrade is available for your seating configuration and covering.'; list.append(warning); }
      setPackageChecks(rows); updateCommitted();
    }
    shared.addEventListener('change', update);
    add.addEventListener('click', function () {
      update(); if (add.disabled) return;
      selections.forEach(function (item, id) { if (item.upgradeKey === key) selections.delete(id); });
      rows.filter(function (row) { return row.check.checked; }).forEach(function (row) {
        var variant = variantFor(row.location, shared.value);
        selections.set(key + '::' + row.location, {upgradeKey:key, productHandle:card.dataset.upgradeProductHandle, seatQuantities:quantities,
          id:variant.id, quantity:cartQuantity(row.location), title:card.querySelector('h3').textContent.trim(), options:variant.options,
          depositPlanIds:variant.depositPlanIds, compareAtCents:variant.compareAtCents, priceCents:variant.priceCents, location:row.location,
          displayDescription: configuration + ' · ' + labelFor(row.location) + (secondary < 0 ? '' : ' · ' + shared.value) + (seatQuantity() > 1 ? ' · ' + seatQuantity() + ' selections' : '')});
      });
      status.textContent = committed().length ? 'Selected. These upgrades will be added with your seating selection.' : 'Upgrades removed.';
      update(); refreshSelection(); compact.collapse();
    });
    remove.addEventListener('click', function () {
      selections.forEach(function (item, id) { if (item.upgradeKey === key) selections.delete(id); }); rows.forEach(function (row) { row.check.checked = false; });
      status.textContent = 'Upgrades removed.'; update(); refreshSelection(); compact.collapse();
    });
    card.refreshQuantityLimits = function () { updateCommitted(); update(); };
    card.committedQuantityLimitError = function () { return ''; };
    card.syncSeatOptions = function (name) { if (name) configuration = name; rebuild(); updateCommitted(); update(); refreshSelection(); };
    rebuild(); update();
  }


  function bootUpgrade(card, selectedUpgrades, quantityDrafts, configurationName, refreshSelection, coveringControl) {
    if (card.dataset.ready) return;
    card.dataset.ready = '1';
    var key = card.dataset.upgradeKey;
    var selectors = Array.from(card.querySelectorAll('[data-upgrade-option]'));
    var packageSelect = selectors.find(function (select) { return matchWords(select.dataset.optionName) === 'panel package'; });
    var configurationSelect = selectors.find(function (select) { return ['configuration', 'seating configuration', 'seat configuration'].includes(matchWords(select.dataset.optionName)); });
    var panelPackage = Boolean(packageSelect && configurationSelect);
    if (panelPackage) {
      card.dataset.panelPackage = 'true';
      var heading = card.querySelector('h3');
      var packageValues = Array.from(packageSelect.options).map(function (option) { return matchWords(option.value); });
      heading.textContent = packageValues.every(function (value) { return value === 'fronts of arms only'; }) ? 'Premium Arm-Front Panels' : packageValues.every(function (value) { return value === 'tops of arms only'; }) ? 'Premium Arm-Top Panels' : 'Premium Panel Packages';
    }
    var quantity = card.querySelector('[data-upgrade-quantity]');
    upgradeStepper(quantity);
    var price = card.querySelector('[data-upgrade-price]');
    var button = card.querySelector('[data-upgrade-add]');
    var remove = card.querySelector('[data-upgrade-remove]');
    var status = card.querySelector('[data-upgrade-status]');
    var quantityNote = card.querySelector('[data-upgrade-quantity-note]');
    var explanationNode = card.querySelector('[data-upgrade-quantity-explanation]');
    var detailsButton = card.querySelector('[data-upgrade-details]');
    var detailsDialog = card.querySelector('[data-upgrade-dialog]');
    var variants = Array.from(card.querySelectorAll('[data-upgrade-variants] span')).map(function (item) {
      return { id: item.dataset.id, options: JSON.parse(item.dataset.options), available: item.dataset.available === 'true', price: item.dataset.price, depositPlanIds: (item.dataset.depositPlanIds || "").split(",").filter(Boolean), compareAtCents: Number(item.dataset.compareAtCents || 0), priceCents: Number(item.dataset.priceCents), image: item.dataset.imageUrl, imageLarge: item.dataset.imageLarge, imageAlt: item.dataset.imageAlt };
    });
    var quiltedUpgrade = /quilt/i.test(card.dataset.upgradeProductHandle + ' ' + card.querySelector('h3').textContent);
    if (panelPackage || quiltedUpgrade) {
      bootPackageList(card, selectedUpgrades, quantityDrafts, configurationName, refreshSelection, variants, selectors, coveringControl, panelPackage);
      bindUpgradeDetails(detailsButton, detailsDialog);
      return;
    }
    if (!panelPackage && card.dataset.selectionLayout !== 'single') {
      var contextOptions = listContext(card, variants, selectors, coveringControl);
      var customerOptions = selectors.filter(function (_, index) { return !contextOptions.automatic.includes(index); });
      if (customerOptions.length <= 2) {
        bootQuantityList(card, selectedUpgrades, quantityDrafts, configurationName, refreshSelection, variants, selectors, coveringControl);
        bindUpgradeDetails(detailsButton, detailsDialog);
        return;
      }
    }
    var compact = compactUpgrade(card, selectedUpgrades, key);
    var packageReminder;
    if (panelPackage) {
      quantity.closest('.cd-upgrade__option').style.display = 'none';
      var packageChoices = new Set(Array.from(packageSelect.options).map(function (option) { return option.value; }));
      if (packageChoices.size === 1) {
        var fixedPackageField = packageSelect.closest('.cd-upgrade__option');
        fixedPackageField.dataset.cdFixedPackage = 'true';
        fixedPackageField.hidden = true;
        fixedPackageField.style.setProperty('display', 'none', 'important');
        packageSelect.tabIndex = -1;
      }
      packageReminder = document.createElement('p');
      packageReminder.className = 'cd-upgrade__package-context';
      packageReminder.style.cssText = 'margin:8px 0 12px;font-size:0.95em;';
      packageReminder.setAttribute('aria-live', 'polite');
      card.querySelector('.cd-upgrade__heading-row').after(packageReminder);
    }
    var preview = variantPreview(card, selectors);
    var selected;
    var configuredQuantities = quantityMap(card);
    var suggested = configuredQuantities.get(normaliseName(configurationName));
    var draft = quantityDrafts.get(key);
    if (draft && draft.customerChanged) quantity.value = draft.quantity;
    else if (suggested) {
      quantity.value = suggested;
      quantityDrafts.set(key, { quantity: suggested, customerChanged: false });
    }
    if (suggested && quantityNote) {
      var explanation = (explanationNode && explanationNode.textContent || '').trim();
      quantityNote.hidden = false;
      quantityNote.textContent = 'Suggested: ' + suggested + (explanation ? ' — ' + explanation : '');
    } else if (quantityNote) {
      quantityNote.hidden = true;
    }
    quantity.addEventListener('input', function () {
      var value = Number(quantity.value);
      if (Number.isSafeInteger(value) && value > 0) quantityDrafts.set(key, { quantity: value, customerChanged: true });
      update();
    });
    function singleMaximum() {
      var base = configuredQuantities.get(normaliseName(configurationName));
      return base === undefined ? undefined : base * (Number(card.dataset.seatOrderQuantity) || 1);
    }
    card.refreshQuantityLimits = update;
    card.committedQuantityLimitError = function () {
      var item = selectedUpgrades.get(key), limit = singleMaximum();
      return item && limit !== undefined && item.quantity > limit ? card.querySelector('h3').textContent.trim() + ' exceeds the maximum of ' + limit + '. Edit the upgrade selection before adding your seat.' : '';
    };
    function update() {
      if (panelPackage) {
        var seatCount = Number(card.dataset.seatOrderQuantity) || 1;
        quantity.value = String(seatCount);
        var reminderText = 'For your ' + configurationName + (seatCount > 1 ? ' · ' + seatCount + ' selections' : '') + ' — upgrade your chosen panel locations across the whole selection.';
        if (packageReminder.textContent !== reminderText) packageReminder.textContent = reminderText;
        Array.from(packageSelect.options).forEach(function (option) {
          var label = panelPackageDescription(option.value, configurationName);
          if (option.textContent !== label) option.textContent = label;
        });
        var committedPackage = selectedUpgrades.get(key);
        if (committedPackage) committedPackage.quantity = seatCount;
      }
      var choices = selectors.map(function (select) { return select.value; });
      selected = variants.find(function (variant) {
        return !selectors.length || variant.options.every(function (value, index) { return value === choices[index]; });
      });
      var offerLabel = card.querySelector('[data-upgrade-free-offer]');
      if (offerLabel) offerLabel.hidden = !selected || !selected.available || selected.priceCents !== 0 || !(selected.compareAtCents > selected.priceCents);
      if (selected) renderUpgradePrice(price, selected.priceCents * (panelPackage ? Number(quantity.value) : 1), selected.compareAtCents * (panelPackage ? Number(quantity.value) : 1), panelPackage ? ' total for your ' + configurationName + (Number(quantity.value) > 1 ? ' × ' + quantity.value : '') : ' each');
      else price.textContent = 'Unavailable combination';
      var limit = singleMaximum();
      var entered = Number(quantity.value);
      var validQuantity = quantity.value !== '' && Number.isSafeInteger(entered) && entered >= 1;
      var excess = limit !== undefined && entered > limit;
      if (limit === undefined) quantity.removeAttribute('max'); else quantity.max = String(limit);
      quantity.cdStepper.refresh();
      quantity.setAttribute('aria-invalid', String(!validQuantity || excess));
      if (quantityNote && !panelPackage) {
        quantityNote.hidden = limit === undefined;
        quantityNote.textContent = limit === undefined ? '' : 'Maximum: ' + limit + (excess ? ' — reduce the quantity to continue.' : (explanationNode && explanationNode.textContent.trim() ? ' — ' + explanationNode.textContent.trim() : ''));
      }
      if (panelPackage && quantityNote) {
        quantityNote.hidden = false;
        var packageNote = panelPackageDescription(packageSelect.value, configurationName) + ' for your ' + configurationName + '. Package quantity follows your seat order.';
        if (quantityNote.textContent !== packageNote) quantityNote.textContent = packageNote;
      }
      button.disabled = !selected || !selected.available || !validQuantity || excess;
      button.textContent = !selected ? 'Unavailable combination' : !selected.available ? 'Sold out' : selectedUpgrades.has(key) ? 'Update selection' : 'Add to selection';
      if (panelPackage && selected && selected.available) button.textContent = selectedUpgrades.has(key) ? 'Update upgrade selection' : 'Add upgrade to selection';
      remove.hidden = !selectedUpgrades.has(key);
      compact.refresh();
      preview.update(selected);
    }
    selectors.forEach(function (select) { select.addEventListener('change', update); });
    button.addEventListener('click', function () {
      update();
      if (button.disabled || !selected || !selected.available) return;
      var count = Number(quantity.value);
      if (!Number.isSafeInteger(count) || count < 1) {
        status.textContent = 'Enter a whole quantity of 1 or more.';
        quantity.focus();
        return;
      }
      selectedUpgrades.set(key, {
        productHandle: card.dataset.upgradeProductHandle,
        seatQuantities: configuredQuantities,
        id: selected.id,
        quantity: count,
        title: card.querySelector('h3').textContent.trim(),
        options: selected.options.filter(function (value) { return value !== 'Default Title'; }),
        depositPlanIds: selected.depositPlanIds,
        compareAtCents: selected.compareAtCents,
        priceCents: selected.priceCents
      });
      quantityDrafts.set(key, { quantity: count, customerChanged: true });
      status.textContent = 'Selected. This upgrade will be added with your seat.';
      update();
      refreshSelection();
      compact.collapse();
    });
    remove.addEventListener('click', function () {
      selectedUpgrades.delete(key);
      status.textContent = 'Upgrade removed from your selection.';
      update();
      refreshSelection();
      compact.collapse();
    });
    bindUpgradeDetails(detailsButton, detailsDialog);
    var lastContext;
    card.syncSeatOptions = function (name) {
      if (name) configurationName = name;
      update();
      var coveringName = selectedValue(coveringControl);
      var context = card.dataset.seatProductTitle + ' ' + card.dataset.seatProductHandle;
      var signature = context + '|' + coveringName + '|' + configurationName;
      if (signature === lastContext) return;
      lastContext = signature;
      var hasAutomatic = false;
      var missing = false;
      selectors.forEach(function (select) {
        var name = matchWords(select.dataset.optionName);
        var isModel = ['seat type', 'sofa model', 'seat model', 'model'].includes(name);
        var isCovering = ['seat covering', 'covering', 'covering material', 'upholstery'].includes(name) ||
          (name === 'material' && /console/i.test(card.dataset.upgradeProductHandle + ' ' + card.querySelector('h3').textContent));
        var isConfiguration = ['configuration', 'seating configuration', 'seat configuration'].includes(name);
        if (!isModel && !isCovering && !isConfiguration) return;
        hasAutomatic = true;
        var values = Array.from(select.options).map(function (option) { return option.value; });
        var value = isConfiguration ? configurationValue(values, configurationName) : automaticValue(values, isModel ? context : coveringName, isCovering);
        select.value = value || '';
        var field = select.closest('.cd-upgrade__option');
        field.hidden = true;
        field.style.display = 'none';
        if (!value) missing = true;
      });
      if (!hasAutomatic) return;
      update();
      var existing = selectedUpgrades.get(key);
      if (existing) {
        if (missing || !selected || !selected.available) {
          selectedUpgrades.delete(key);
          status.textContent = 'Upgrade removed: unavailable for this sofa and covering.';
        } else {
          existing.id = selected.id;
          existing.options = selected.options.filter(function (value) { return value !== 'Default Title'; });
          existing.priceCents = selected.priceCents;
          existing.compareAtCents = selected.compareAtCents;
          existing.depositPlanIds = selected.depositPlanIds;
          status.textContent = 'Selected upgrade matched to your seating configuration, sofa and covering.';
        }
        update();
        refreshSelection();
      } else if (missing) {
        status.textContent = 'This upgrade has no matching option for your seating configuration, sofa and covering.';
      } else {
        status.textContent = '';
      }
    };
    var previous = selectedUpgrades.get(key);
    if (previous) {
      var previousVariant = variants.find(function (variant) { return String(variant.id) === String(previous.id); });
      if (previousVariant) {
        selectors.forEach(function (select, index) { select.value = previousVariant.options[index]; });
        quantity.value = previous.quantity;
      }
    }
    update();
    card.syncSeatOptions();
  }

  function upgradeCartItem(upgrade, seatPlan) {
    var item = { id: upgrade.id, quantity: upgrade.quantity };
    if (!seatPlan) return item;
    var plans = Array.from(new Set(upgrade.depositPlanIds || []));
    var selectedPlan = plans.includes(String(seatPlan)) ? String(seatPlan) : plans.length === 1 ? plans[0] : null;
    if (!selectedPlan) {
      throw new Error('Cannot apply the 50% deposit to ' + upgrade.title + '. Please contact us so we can confirm its deposit option.');
    }
    item.selling_plan = selectedPlan;
    return item;
  }

  function boot(host) {
    if (host.dataset.watching) return;
    host.dataset.watching = '1';
    var scope = host.closest('main') || document.querySelector('main') || document;
    var currentPicker = null;
    var panelState = { configuration: true, covering: false, extras: false };
    var selectedUpgrades = new Map();
    // One shared source for preview and actual add-to-cart quantities/plans.
    host.cdGetQuoteItems = function (form) {
      var data = new FormData(form);
      var item = { id: String(data.get('id') || ''), quantity: Number(data.get('quantity') || 1) };
      if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
      item.properties = {};
      data.forEach(function (value, key) {
        if (key.startsWith('properties[') && key.endsWith(']') && typeof value === 'string' && value !== '') {
          item.properties[key.slice(11, -1)] = value;
        }
      });
      return [item].concat(Array.from(selectedUpgrades.values()).map(function (upgrade) {
        return upgradeCartItem(upgrade, data.get('selling_plan'));
      }));
    };
    var quantityDrafts = new Map();
    var currentForm = null;
    var productSection = null;
    var addingBundle = false;
    var timer;
    var observer;
    var refreshControlsWarning = function () {};
    function quantityChanged(event) {
      if (event.target.name === 'quantity' && event.target.form === currentForm) refreshControlsWarning();
    }
    document.addEventListener('input', quantityChanged);
    document.addEventListener('change', quantityChanged);

    function money(pence) {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(pence / 100);
    }

    async function addSeatAndUpgrades(form, submitButton) {
      if (addingBundle) return;
      if (!form || !form.reportValidity()) return;
      var data = new FormData(form);
      var seatId = data.get('id') || form.querySelector('[name="id"]')?.value;
      var seatQuantity = Number(data.get('quantity') || 1);
      var status = form.querySelector('[data-cinema-deco-cart-status]');
      if (!status) {
        status = document.createElement('p');
        status.dataset.cinemaDecoCartStatus = '';
        status.setAttribute('role', 'status');
        form.append(status);
      }
      if (!seatId || !Number.isSafeInteger(seatQuantity) || seatQuantity < 1) {
        status.textContent = 'Choose a seat and a valid quantity before adding to cart.';
        return;
      }
      refreshControlsWarning();
      var limitError = productSection && Array.from(productSection.querySelectorAll('[data-cinema-deco-upgrade]')).map(function (card) { return card.committedQuantityLimitError ? card.committedQuantityLimitError() : ''; }).find(Boolean);
      if (limitError) { status.textContent = limitError; return; }
      var properties = {};
      data.forEach(function (value, key) {
        if (key.startsWith('properties[') && key.endsWith(']') && value !== '') {
          properties[key.slice(11, -1)] = value;
        }
      });
      var seatItem = { id: seatId, quantity: seatQuantity };
      if (Object.keys(properties).length) seatItem.properties = properties;
      if (data.get('selling_plan')) seatItem.selling_plan = data.get('selling_plan');
      var items;
      try {
        items = [seatItem].concat(Array.from(selectedUpgrades.values()).map(function (upgrade) {
          return upgradeCartItem(upgrade, data.get('selling_plan'));
        }));
      } catch (error) {
        status.textContent = error.message;
        return;
      }
      addingBundle = true;
      if (submitButton) submitButton.disabled = true;
      status.textContent = 'Adding your seat and upgrades…';
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      try {
        var response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Could not add your seat and upgrades.');
        // Items have been added. Never retry that add if saving the code fails.
        if (host.cdDiscountCodes?.length) {
          try {
            var cartResponse = await fetch(root + 'cart.js', { cache: 'no-store' });
            if (!cartResponse.ok) throw new Error('Cart unavailable');
            var cartNow = await cartResponse.json();
            var codes = Array.from(new Set((cartNow.discount_codes || []).map(function (entry) { return entry.code; }).concat(host.cdDiscountCodes)));
            var codeResponse = await fetch(root + 'cart/update.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: codes.join(',') })
            });
            if (!codeResponse.ok) throw new Error('Code unavailable');
          } catch (_) {
            status.textContent = 'Your items were added. Please enter your discount code in the basket. ';
            var cartLink = document.createElement('a');
            cartLink.href = root + 'cart'; cartLink.textContent = 'View basket';
            status.append(cartLink);
            return;
          }
        }
        window.location.assign(root + 'cart');
      } catch (error) {
        status.textContent = error.message || 'Please try again.';
        addingBundle = false;
        if (submitButton) submitButton.disabled = false;
      }
    }

    function seatForm(form) {
      return form && productSection && productSection.contains(form) && form.querySelector('[name="id"]') && /\/cart\/add/.test(form.getAttribute('action') || '');
    }

    document.addEventListener('click', function (event) {
      if ((selectedUpgrades.size === 0 && !host.cdDiscountCodes?.length) || !productSection) return;
      var button = event.target.closest('button, input[type="submit"]');
      if (!button || !productSection.contains(button)) return;
      if (!button.matches('[name="add"], .product-form__submit, button[type="submit"], input[type="submit"]')) return;
      var form = button.form || button.closest('form') || currentForm;
      if (!seatForm(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addSeatAndUpgrades(form, button);
    }, true);

    document.addEventListener('submit', function (event) {
      if ((selectedUpgrades.size === 0 && !host.cdDiscountCodes?.length) || !seatForm(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addSeatAndUpgrades(event.target, event.submitter);
    }, true);

    function mount() {
      if (!host.isConnected) {
        document.removeEventListener('input', quantityChanged);
        document.removeEventListener('change', quantityChanged);
        if (observer) observer.disconnect();
        return;
      }
      var picker = Array.from(scope.querySelectorAll('variant-selects')).find(function (item) {
        return optionControl(item, 'configuration') && optionControl(item, 'seat covering');
      });
      if (!picker) {
        refreshControlsWarning();
        if (currentPicker && currentPicker.isConnected) {
          productSection = currentPicker.closest('[id^="shopify-section-"]') || scope;
          currentForm = productSection.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
        }
        return;
      }
      if (picker === currentPicker && picker.querySelector(':scope > .cd-steps__item')) {
        productSection = picker.closest('[id^="shopify-section-"]') || scope;
        currentForm = productSection.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
        return;
      }
      var configuration = optionControl(picker, 'configuration');
      var covering = optionControl(picker, 'seat covering');
      if (!configuration || !covering) return;
      currentPicker = picker;
      productSection = picker.closest('[id^="shopify-section-"]') || scope;
      currentForm = productSection.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');

      scope.querySelectorAll('.cd-steps__external').forEach(function (oldPanel) { oldPanel.remove(); });
      // Rebuild only this section's promotional box when the variant picker is replaced.
      scope.querySelectorAll('[data-cd-promo-owner]').forEach(function (node) {
        if (node.dataset.cdPromoOwner === host.id) node.remove();
      });
      var promoTemplate = host.querySelector('[data-cd-promo-template]');
      if (promoTemplate) {
        var promoBox = promoTemplate.content.firstElementChild.cloneNode(true);
        promoBox.dataset.cdPromoOwner = host.id;
        picker.before(promoBox);
      }
      picker.classList.add('cd-steps');
      var configStep = makeStep('1. Configuration', selectedValue(configuration));
      var coveringStep = makeStep('2. Choose your covering', selectedValue(covering) + ' · colour confirmed after samples');
      var extrasStep = makeStep('3. Extras & upgrades', 'Optional products');
      var promoText = (host.dataset.cdUpgradePromo || '').trim();
      if (promoText) {
        var promoLine = document.createElement('span');
        promoLine.className = 'cd-seat-promo__upgrade-line';
        promoLine.textContent = promoText;
        extrasStep.selection.before(promoLine);
      }
      configStep.details.open = panelState.configuration;
      coveringStep.details.open = panelState.covering;
      extrasStep.details.open = panelState.extras;
      configStep.details.addEventListener('toggle', function () { panelState.configuration = configStep.details.open; });
      coveringStep.details.addEventListener('toggle', function () { panelState.covering = coveringStep.details.open; });
      extrasStep.details.addEventListener('toggle', function () { panelState.extras = extrasStep.details.open; });
      picker.insertAdjacentElement('afterend', extrasStep.details);
      extrasStep.details.classList.add('cd-steps__external');
      picker.insertBefore(configStep.details, configuration);
      picker.insertBefore(coveringStep.details, configuration);
      configStep.body.append(configuration);
      coveringStep.body.append(covering);
      var dimensions = document.createElement('div');
      dimensions.className = 'cd-steps__dimensions';
      dimensions.setAttribute('role', 'status');
      dimensions.setAttribute('aria-live', 'polite');
      dimensions.setAttribute('aria-atomic', 'true');
      if (!document.getElementById('cd-seat-dimensions-style')) {
        var dimensionsStyle = document.createElement('style');
        dimensionsStyle.id = 'cd-seat-dimensions-style';
        dimensionsStyle.textContent = `
          .cd-steps > .cd-steps__dimensions { box-sizing:border-box; margin:0; padding:18px 20px 20px; background:#f6f5f1; border:0; border-bottom:1px solid #ddd8d0; color:#242424; text-align:left; }
          .cd-steps > .cd-steps__dimensions[hidden] { display:none; }
          .cd-steps__dimensions .cd-dimensions__title { margin:0 0 14px; color:#6b665f; font-size:11px; font-weight:600; line-height:1.4; letter-spacing:.1em; text-transform:uppercase; }
          .cd-steps__dimensions .cd-dimensions__grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(110px,1fr)); gap:16px; margin:0; padding:0; }
          .cd-steps__dimensions .cd-dimensions__metric { margin:0; min-width:0; }
          .cd-steps__dimensions dt { margin:0 0 5px; padding:0; color:#66615b; font-size:12px; font-weight:400; line-height:1.4; letter-spacing:0; }
          .cd-steps__dimensions dd { margin:0; padding:0; color:#242424; font-size:22px; font-weight:500; line-height:1.25; letter-spacing:0; font-variant-numeric:tabular-nums; white-space:nowrap; }
          .cd-steps__dimensions .cd-dimensions__unit { margin-left:4px; color:#6b665f; font-size:12px; font-weight:400; }
          .cd-steps__dimensions .cd-dimensions__note { margin:12px 0 0; color:#66615b; font-size:12px; line-height:1.5; }
          .cd-steps__dimensions .cd-dimensions__pending { margin:0; color:#66615b; font-size:13px; line-height:1.5; }
          @media(max-width:480px) {
            .cd-steps > .cd-steps__dimensions { padding:16px; }
            .cd-steps__dimensions .cd-dimensions__grid { grid-template-columns:1fr; gap:10px; }
            .cd-steps__dimensions .cd-dimensions__metric { display:flex; align-items:baseline; justify-content:space-between; gap:16px; }
            .cd-steps__dimensions dt { margin:0; }
            .cd-steps__dimensions dd { font-size:19px; }
          }
        `;
        document.head.append(dimensionsStyle);
      }
      // Keep the dimensions visible even when the configuration choices are collapsed.
      configStep.details.insertAdjacentElement('afterend', dimensions);
      var lastDimensionsSignature;
      function refreshDimensions() {
        var source = host.querySelector('[data-cd-dimensions]');
        dimensions.hidden = !source;
        if (!source) return;
        var data;
        try { data = JSON.parse(source.textContent); } catch (error) { data = null; }
        var result = calculateDimensions(data, selectedValue(configuration), Array.from(selectedUpgrades.values()));
        var signature = JSON.stringify(result);
        if (signature === lastDimensionsSignature) return;
        lastDimensionsSignature = signature;
        dimensions.replaceChildren();
        var title = document.createElement('p');
        title.className = 'cd-dimensions__title';
        title.textContent = 'Dimensions';
        dimensions.append(title);
        if (result) {
          var grid = document.createElement('dl');
          grid.className = 'cd-dimensions__grid';
          var metrics = [['Overall width', result.width], ['Upright depth', result.depth]];
          if (result.reclined) metrics.push(['Fully reclined depth', result.reclined]);
          metrics.forEach(function (metric) {
            var cell = document.createElement('div');
            cell.className = 'cd-dimensions__metric';
            var label = document.createElement('dt');
            label.textContent = metric[0];
            var value = document.createElement('dd');
            value.textContent = metric[1].toLocaleString('en-GB', { maximumFractionDigits: 1 });
            var unit = document.createElement('span');
            unit.className = 'cd-dimensions__unit';
            unit.textContent = 'mm';
            value.append(document.createTextNode(' '), unit);
            cell.append(label, value);
            grid.append(cell);
          });
          dimensions.append(grid);
          if (result.count) {
            var consoleNote = document.createElement('p');
            consoleNote.className = 'cd-dimensions__note';
            consoleNote.textContent = 'Includes ' + result.count + (result.count === 1 ? ' console replacement' : ' console replacements');
            dimensions.append(consoleNote);
          }
        } else {
          var pending = document.createElement('p');
          pending.className = 'cd-dimensions__pending';
          pending.textContent = 'Dimensions to be confirmed for this selection.';
          dimensions.append(pending);
        }
      }

      var note = document.createElement('p');
      note.className = 'cd-steps__note';
      note.textContent = 'Choose a covering type now. Confirm your exact colour after your samples arrive.';
      coveringStep.body.append(note);
      document.dispatchEvent(new CustomEvent('cinema-deco:covering-control-ready'));

      var extrasSource = host.querySelector('[data-cinema-deco-extras]');
      var extras = extrasSource && extrasSource.cloneNode(true);
      if (extras) {
        extrasStep.body.append(extras);
      }
      extrasStep.details.hidden = !extras || !extras.querySelector('[data-cinema-deco-upgrade]');

      var chosen = document.createElement('div');
      chosen.className = 'cd-steps__chosen';
      chosen.hidden = true;
      chosen.innerHTML = '<strong>Your selected upgrades</strong><ul></ul><p class="cd-steps__chosen-total"></p>';
      extrasStep.body.append(chosen);
      var warning = document.createElement('p');
      warning.setAttribute('role', 'status');
      warning.setAttribute('aria-live', 'polite');
      warning.hidden = true;
      warning.style.cssText = 'padding:12px 16px;border:1px solid #b45309;border-radius:6px;background:#fff7ed;color:#7c2d12;font-weight:600;';
      extrasStep.body.prepend(warning);
      refreshControlsWarning = function () {
        var rowQuantity = currentForm ? Number(new FormData(currentForm).get('quantity') || 1) : 1;
        if (productSection) productSection.querySelectorAll('[data-cinema-deco-upgrade]').forEach(function (card) {
          card.dataset.seatOrderQuantity = String(rowQuantity);
          if (card.refreshQuantityLimits) card.refreshQuantityLimits();
        });
        var message = controlsWarning(Array.from(selectedUpgrades.values()), selectedValue(configuration), rowQuantity);
        if (warning.textContent !== message) warning.textContent = message;
        warning.hidden = !message;
        if (message) extrasStep.details.open = true;
      };
      function refreshSelection() {
        refreshDimensions();
        refreshControlsWarning();
        var values = Array.from(selectedUpgrades.values());
        var count = values.length;
        var total = values.reduce(function (sum, item) { return sum + item.priceCents * item.quantity; }, 0);
        // Publish exact committed selections for the Custom Liquid price summary.
        var originalTotal = values.reduce(function (sum, item) { return sum + Math.max(item.priceCents, item.compareAtCents || 0) * item.quantity; }, 0);
        host.dataset.cdUpgradeOriginalTotal = String(originalTotal);
        host.dataset.cdUpgradeTotal = String(total);
        host.dataset.cdUpgradeCount = String(count);
        host.dataset.cdProductSection = productSection.id || '';

        extrasStep.selection.textContent = count ? count + (count === 1 ? ' upgrade selected' : ' upgrades selected') + ' · ' + money(total) : 'Optional products';
        chosen.hidden = !count;
        var list = chosen.querySelector('ul');
        list.replaceChildren();
        values.forEach(function (item) {
          var li = document.createElement('li');
          li.textContent = item.title + ' — ' + (item.displayDescription || item.quantity + ' × ' + item.options.join(' / '));
          var linePrice = document.createElement('span'); linePrice.className = 'cd-upgrade-line-price';
          renderUpgradePrice(linePrice, item.priceCents * item.quantity, Math.max(item.priceCents, item.compareAtCents || 0) * item.quantity);
          li.append(linePrice);
          list.append(li);
        });
        var chosenTotal = chosen.querySelector('.cd-steps__chosen-total');
        renderUpgradePrice(chosenTotal, total, originalTotal);
        chosenTotal.prepend(document.createTextNode('Upgrades and Extras: '));
        if (originalTotal > total) {
          var saving = document.createElement('span'); saving.className = 'cd-price-saving';
          saving.textContent = 'You save ' + money(originalTotal - total); chosenTotal.append(saving);
        }
        productSection.classList.toggle('cd-has-selected-upgrades', count > 0);
      }
      if (extras) extras.querySelectorAll('[data-cinema-deco-upgrade]').forEach(function (card) {
        bootUpgrade(card, selectedUpgrades, quantityDrafts, selectedValue(configuration), refreshSelection, covering);
      });
      refreshSelection();

      function updateSummaries() {
        if (extras) extras.querySelectorAll('[data-cinema-deco-upgrade]').forEach(function (card) {
          if (card.syncSeatOptions) card.syncSeatOptions(selectedValue(configuration));
        });
        refreshControlsWarning();
        refreshDimensions();
        var selectedConfiguration = selectedValue(configuration);
        var selectedCovering = selectedValue(covering) + ' · colour confirmed after samples';
        if (configStep.selection.textContent !== selectedConfiguration) configStep.selection.textContent = selectedConfiguration;
        if (coveringStep.selection.textContent !== selectedCovering) coveringStep.selection.textContent = selectedCovering;
      }
      picker.addEventListener('change', updateSummaries);
      picker.addEventListener('input', updateSummaries);
      updateSummaries();
      // The covering drawer manages its own launch button so it survives picker refreshes.
    }

    observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(mount, 0);
    });
    observer.observe(scope, { childList: true, subtree: true });
    mount();
  }

  function bootAll() {
    document.querySelectorAll('[data-cinema-deco-steps]').forEach(boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
